// Module
var code = "<div class=\"block height-100\"> <h2> :entityName - Financials DB Numbers</h2> <p><a href=\"/app/admin/entity/:accountingOrganisationId\">Admin Entity</a></p> <div id=\"numbersGrid\" class=\"height-100 padding-bottom-30\"></div> </div> ";
// Exports
export default code;